import React, { FC, useState, useRef, useEffect } from 'react'
import i18n from 'i18next'
import './index.scss'
import { Observer } from 'mobx-react-lite'

interface IProps {
  join?: string;
  data: any[];
}

const StoreShow: FC<IProps> = (props: IProps) => {
  const { join = ' / ', data } = props
  const hideRef: any = useRef<any>(null)
  const [show, setShow] = useState<boolean>(false)
  const [hasOpera, setHasOpera] = useState<boolean>(false)
  useEffect(() => {
    setTimeout(() => {
      if (hideRef && hideRef.current) {
        if (hideRef.current.scrollHeight > 20) {
          setHasOpera(true)
        } else {
          setHasOpera(false)
        }
      }
    }, 100)
  }, [])
  return (
    <div className='mkt-list-show'>
      {!show && <div className='hide-area' ref={hideRef}>{data.join(join)}</div>}
      {
        show &&
          <>
            {
              data.map((item: any, index: any) => (
                <div key={index}>{item}</div>
              ))
            }
          </>
      }
      {
        hasOpera && <div className='opera' data-cypid='mktListShowClick' onClick={() => setShow(!show)}> {show ? i18n.t('mkt.common.putAway') : i18n.t('mkt.common.clickToExpand')} </div>
      }
    </div>
  )
}
export default StoreShow
